import { IRender } from '../parseTreeToHtml.types';

export const underlineRender: IRender = (text): string => {
  if (!text) {
    return '';
  }

  return `<u>${text}</u>`;
};
